import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from './environments/environment';

import { isAdminHost, isFittaraCompassHost } from './app/shared/utils/host-classification.util';
import { applyRuntimeEnvironmentOverrides } from './app/shared/utils/runtime-environment.util';
import { ensureMaterialTheme } from './app/shared/utils/conditional-stylesheet.util';

applyRuntimeEnvironmentOverrides();

if (environment.production) {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
}

const hostname = window.location.hostname.toLowerCase();
const isAdminSubdomain = isAdminHost(hostname);
const isFittaraCompassSubdomain = isFittaraCompassHost(hostname);
const isDelegatedShopAccess = isAdminSubdomain && window.location.pathname.startsWith('/shop-access/');

if (isAdminSubdomain) {
  ensureMaterialTheme();
}

if (isAdminSubdomain && !isDelegatedShopAccess) {
  import('./app/AdminPortal/admin-portal.module')
    .then(({ AdminPortalModule }) => platformBrowserDynamic().bootstrapModule(AdminPortalModule))
    .catch((err) => console.log(err));
} else if (isFittaraCompassSubdomain) {
  import('./app/FittaraCompassPortal/fittara-compass.module')
    .then(({ FittaraCompassModule }) => platformBrowserDynamic().bootstrapModule(FittaraCompassModule))
    .catch((err) => console.log(err));
} else {
  import('./app/app.module')
    .then(({ AppModule }) => platformBrowserDynamic().bootstrapModule(AppModule))
    .catch((err) => console.log(err));
}
